angular.module('appSettingWelcome', [
  'ngRoute',
  'ngResource',
  'ngFileUpload',
  'core',
  'core.auth',
  'core.env',
  'pascalprecht.translate',
]);



// WEBPACK FOOTER //
// ./src/app/app-setting/welcome/welcome.module.js